import React from 'react'
import styled from '@emotion/styled'
import {TranslatedLOVItem} from '@findhotel/sapi'
import {LovHit} from 'modules/search/slice'

import {Box} from '@vio/atlas/helpers/Box'
import {Text} from '@vio/atlas/Text'
import {cssTheme} from '@vio/atlas/themes'
import FormattedMessageWrapper from '@vio/core/src/localization/components/FormattedMessage'

import {FacilityIcon} from './FacilityIcon'

const GridWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  column-gap: ${cssTheme.layout.spacing.s600};
  row-gap: ${cssTheme.layout.spacing.s400};
  margin-top: ${cssTheme.layout.spacing.s500};
`

interface Props {
  facilities?: TranslatedLOVItem[]
}
export const PopularAmenities: React.FC<Props> = ({facilities}) => {
  if (!Array.isArray(facilities)) return null
  return (
    <div>
      <Text variant="titleM">
        <FormattedMessageWrapper
          id="popularAmenities"
          defaultMessage="Popular amenities"
        />
      </Text>
      <GridWrapper>
        {facilities?.map(facility => (
          <Box display="flex" alignItems="center" gap="s300" key={facility.id}>
            <div>
              <FacilityIcon facility={facility as LovHit} />
            </div>
            <Text variant="bodyM">{facility.value}</Text>
          </Box>
        ))}
      </GridWrapper>
    </div>
  )
}
